/** Resolves display text only; canonical role strings continue to control authorization. */
export function roleLabel(role: string, adminTitle?: string | null): string {
  if (role === "Admin") return adminTitle?.trim() || "مدیر";
  if (role === "Teacher") return "معلم";
  if (role === "Student") return "دانش‌آموز";
  return role;
}
